import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "errPage-container"
};
var _hoisted_2 = ["src"];
import gif_401 from '@/assets/401_images/401.gif';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: '401',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var errGif = ref(gif_401 + '?' + +new Date());
    function back() {
      if (route.query.noGoBack) {
        router.push({
          path: '/home'
        });
      } else {
        router.go(-1);
      }
    }
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(function () {
              return [_cache[1] || (_cache[1] = _createElementVNode("h1", {
                class: "text-jumbo text-ginormous"
              }, " 对不起！ ", -1)), _cache[2] || (_cache[2] = _createElementVNode("h2", null, "您没有权限访问该页面...", -1)), _cache[3] || (_cache[3] = _createElementVNode("h6", null, "请确认地址栏中的URL是否正确，或联系系统管理员。", -1)), _createVNode(_component_el_button, {
                icon: "Arrow-left",
                class: "pan-back-btn",
                onClick: back
              }, {
                default: _withCtx(function () {
                  return _cache[0] || (_cache[0] = [_createTextVNode(" 回到首页 ")]);
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("img", {
                src: errGif.value,
                width: "313",
                height: "428",
                alt: "Girl has dropped her ice cream."
              }, null, 8, _hoisted_2)];
            }),
            _: 1
          })];
        }),
        _: 1
      })]);
    };
  }
});